import api from "@/lib/api";

// "1.0.0" -> "1.0", "1.1.0" -> "1.1", "1.1.3" -> "1.1.3" (la fel ca backend/core/version.py:version_label)
export const versionLabel = (v) => {
  const m = /^(\d+)\.(\d+)\.(\d+)$/.exec(v || "");
  return m ? (m[3] === "0" ? `${m[1]}.${m[2]}` : v) : (v || "");
};

// Versiunea platformei, citită o singură dată din /api/health (nu cere autentificare).
let cached = null;
export const loadPlatformVersion = () => {
  if (!cached) cached = api.get("/health").then(r => r.data.version_label || versionLabel(r.data.version)).catch(() => "");
  return cached;
};
